function buildDefaultNewAccount() {
    return {
        type: 'free',
        trialPeriod: 30,
        alpha: false,
        beta: false,
        customApps: false,
        codePinPairing: false,
        enabled: true,
        accountVerified: true,
        subscriptions: 10,
    };
}

function deriveAccountStartDate(account) {
    if (account.type === 'paid') {
        return new Date();
    }
    if (account.type === 'free') {
        return null;
    }
    return account.startDate;
}

function buildCreateAccountPayload(account, user) {
    return { account: account, user: user };
}

if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
    module.exports = {
        buildDefaultNewAccount: buildDefaultNewAccount,
        deriveAccountStartDate: deriveAccountStartDate,
        buildCreateAccountPayload: buildCreateAccountPayload,
    };
}

if (typeof angular !== 'undefined') {
(function (module) {
    'use strict';

    function AdminAddAccountCtrl(Account, $state) {
        this.$onInit = () => {
            this.account = buildDefaultNewAccount();
        };
        this.checkType = () => {
            this.account.startDate = deriveAccountStartDate(this.account);
        };

        this.save = () => {
            this.apiError = {};
            Account
                .createAccountWithPrimaryUser(buildCreateAccountPayload(this.account, this.user))
                .$promise
                .then((response) => {
                    $state.go('root.admin.accounts.view', { accountId: response.account.id });

                })
                .catch((error) => {
                    if (error.status === 422) {
                        this.apiError.message = 'Email already exists';
                    }

                });
        };
    }

    module
        .component('adminAddAccountComponent', {
            templateUrl: '/js/admin/accounts/add-account/add-account.html',
            controller: AdminAddAccountCtrl
        })
        .config(($stateProvider) => {
            $stateProvider
                .state('root.admin.accounts.add', {
                    url: '/add',
                    data: {
                        pageTitle: 'ADMIN_ACCOUNTS_ADD.PAGE_TITLE'
                    },
                    views: {
                        'content@root': {
                            template: '<admin-add-account-component/>'
                        }
                    }
                });

        });

})(angular.module('rocket.components'));
}
